import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { theme } from '_constants/theme';

import Card from '_components/atomic/layouts/Card';

const SimpleSystemSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={32}
    width={32}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g>
      <path
        d="M21.8737 10.4063C21.1936 6.1599 17.8401 2.8064 13.5937 2.12631C13.1286 2.05181 12.8961 2.01457 12.6477 2.10809C12.45 2.18249 12.2364 2.36467 12.1316 2.54805C12 2.77854 12 3.05236 12 3.6V8.8C12 9.9201 12 10.4802 12.218 10.908C12.4097 11.2843 12.7157 11.5903 13.092 11.782C13.5198 12 14.0799 12 15.2 12H20.4C20.9476 12 21.2215 12 21.452 11.8684C21.6353 11.7636 21.8175 11.55 21.8919 11.3523C21.9854 11.1039 21.9482 10.8714 21.8737 10.4063Z"
        stroke="#1a9ac7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 2.45801C4.94289 3.73227 2 7.52256 2 12.0002C2 17.5231 6.47715 22.0002 12 22.0002C16.4776 22.0002 20.2679 19.0573 21.5422 15.0002"
        stroke="#1b1b1b"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const AffordableSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={32}
    width={32}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g>
      <path
        d="M9 14C9 15.1046 9.89543 16 11 16H13.2566C14.2194 16 15 15.2194 15 14.2566C15 13.5062 14.5198 12.8399 13.8079 12.6026L10.1921 11.3974C9.48019 11.1601 9 10.4938 9 9.74342C9 8.78055 9.78055 8 10.7434 8H13C14.1046 8 15 8.89543 15 10M12 6.5V17.5"
        stroke="#1a9ac7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#1b1b1b"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const OngoingSupportSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={32}
    width={32}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g>
      <path
        d="M22 17V12C22 11.3151 21.9311 10.6462 21.8 10M2 17V12C2 11.3151 2.06886 10.6462 2.20004 10M19 22V22C19.9319 22 20.3978 22 20.7654 21.8478C21.2554 21.6448 21.6448 21.2554 21.8478 20.7654C22 20.3978 22 19.9319 22 19V16C22 15.0681 22 14.6022 21.8478 14.2346C21.6448 13.7446 21.2554 13.3552 20.7654 13.1522C20.3978 13 19.9319 13 19 13V13C18.0681 13 17.6022 13 17.2346 13.1522C16.7446 13.3552 16.3552 13.7446 16.1522 14.2346C16 14.6022 16 15.0681 16 16V19C16 19.9319 16 20.3978 16.1522 20.7654C16.3552 21.2554 16.7446 21.6448 17.2346 21.8478C17.6022 22 18.0681 22 19 22ZM5 22V22C5.93188 22 6.39782 22 6.76537 21.8478C7.25542 21.6448 7.64477 21.2554 7.84776 20.7654C8 20.3978 8 19.9319 8 19V16C8 15.0681 8 14.6022 7.84776 14.2346C7.64477 13.7446 7.25542 13.3552 6.76537 13.1522C6.39782 13 5.93188 13 5 13V13C4.06812 13 3.60218 13 3.23463 13.1522C2.74458 13.3552 2.35523 13.7446 2.15224 14.2346C2 14.6022 2 15.0681 2 16V19C2 19.9319 2 20.3978 2.15224 20.7654C2.35523 21.2554 2.74458 21.6448 3.23463 21.8478C3.60218 22 4.06812 22 5 22Z"
        stroke="#1a9ac7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.20001 10C3.12655 5.43552 7.16206 2 12 2C16.8379 2 20.8734 5.43552 21.7999 10"
        stroke="#1b1b1b"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const StyledOuterContainer = styled.div`
  max-width: ${theme.spaces.large32X * 10}px;
  width: 100%;
  position: relative;
`;

const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: ${theme.spaces.large24X}px;
  padding-bottom: ${theme.spaces.large24X}px;
  border-top-left-radius: 32px;
  border-bottom-left-radius: 32px;
  /* border-top: 1px solid ${theme.colors.gray[200]}; */
  border-left: 1px solid ${theme.colors.gray[200]};

  @media ${theme.devices.tablet} {
    padding-top: ${theme.spaces.large10X}px;
    padding-bottom: ${theme.spaces.regular}px;
    border-radius: unset;
    border-left: unset;
  }
`;

const StyledCardsContainer = styled.div`
  display: grid;
  width: 80%;
  grid-template-columns: 50% 50%;
  column-gap: ${theme.spaces.large2X}px;
  row-gap: ${theme.spaces.large2X * 2}px;

  @media ${theme.devices.tablet} {
    width: 100%;
    padding: ${theme.spaces.regular}px;
    grid-template-columns: 100%;
    row-gap: ${theme.spaces.large2X}px;
  }
`;

const StyledOuterCardContainer = styled.div`
  padding: ${theme.spaces.smallX}px;
  border-radius: 40px;
  border: 1px solid ${theme.colors.gray[200]};
`;

const StyledInnerCardContainer = styled.div`
  padding: ${theme.spaces.large}px;
  border-radius: 32px;
  background-color: ${theme.colors.gray[50]};
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;
  width: 90px;
  margin-bottom: ${theme.spaces.large2X}px;
  border-radius: 16px;
  background-color: ${theme.colors.white};
`;

const StyledCurve = styled.div`
  height: ${theme.spaces.large24X}px;
  width: 60%;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: -100%;
    height: 100%;
    width: 50%;
    border-bottom-left-radius: 32px;
    border-bottom: 1px solid ${theme.colors.gray[200]};
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: -1px;
    height: 100%;
    width: 50%;
    border-top-right-radius: 32px;
    border-top: 1px solid ${theme.colors.gray[200]};
  }

  @media ${theme.devices.tablet} {
    display: none;
  }
`;

const StyledLine = styled.div`
  display: block;
  position: absolute;
  left: calc(60% - 47px);
  bottom: 45px;
  height: 1px;
  width: 130px;
  background-color: ${theme.colors.gray[200]};
  transform: rotate(69deg);

  @media ${theme.devices.tablet} {
    display: none;
  }
`;

const WhyIncorpifiedSection = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <Card.Text
          size={theme.fontSizes.large9X}
          weight={500}
          bottomSpace={theme.spaces.large}
          centered
        >
          Why Choose Incorpified?
        </Card.Text>
        <Card.Text
          size={theme.fontSizes.largeX}
          weight={300}
          bottomSpace={isMobile ? theme.spaces.large4X : theme.spaces.large10X}
          centered
        >
          We Make Starting Your LLC Easy
        </Card.Text>
        <StyledCardsContainer>
          <StyledOuterCardContainer>
            <StyledInnerCardContainer>
              <StyledIconContainer>
                <SimpleSystemSvg />
              </StyledIconContainer>
              <Card.Text
                size={theme.fontSizes.large2X}
                weight={600}
                bottomSpace={theme.spaces.regular}
              >
                Simple System
              </Card.Text>
              <Card.Text size={theme.fontSizes.medium} weight={300}>
                Our proprietary filing system makes everything simple. From
                company name availability verification and preparation of
                documents to filing and industry-leading customer support.
              </Card.Text>
            </StyledInnerCardContainer>
          </StyledOuterCardContainer>
          <StyledOuterCardContainer>
            <StyledInnerCardContainer>
              <StyledIconContainer>
                <AffordableSvg />
              </StyledIconContainer>
              <Card.Text
                size={theme.fontSizes.large2X}
                weight={600}
                bottomSpace={theme.spaces.regular}
              >
                Affordable
              </Card.Text>
              <Card.Text size={theme.fontSizes.medium} weight={300}>
                Our basic filing is affordable, with plans starting at $0 plus
                your state filing fee. We believe that starting your company
                shouldn&apos;t drain the bank before you even get started.
              </Card.Text>
            </StyledInnerCardContainer>
          </StyledOuterCardContainer>
          <StyledOuterCardContainer>
            <StyledInnerCardContainer>
              <StyledIconContainer>
                <OngoingSupportSvg />
              </StyledIconContainer>
              <Card.Text
                size={theme.fontSizes.large2X}
                weight={600}
                bottomSpace={theme.spaces.regular}
              >
                Ongoing Support
              </Card.Text>
              <Card.Text size={theme.fontSizes.medium} weight={300}>
                We make registering a company as easy as possible. Beyond that,
                we have a full suite of startup services (like banking and
                bookkeeping), which means Incorpified not only helps you get
                started but supports you in your continued success. We&apos;re
                your one-stop shop.
              </Card.Text>
            </StyledInnerCardContainer>
          </StyledOuterCardContainer>
        </StyledCardsContainer>
      </StyledInnerContainer>
      <StyledCurve />
      <StyledLine />
    </StyledOuterContainer>
  );
};

export default WhyIncorpifiedSection;
